import { Cursor } from "../../cursor";
import { MarshalParameters } from "../../marshal";
import {Action} from "../../action";

export class SetRegister extends Action
{
    constructor()
    {
        super({
            description: "Set the register to the passed value",
            parameters: {
                key: {
                    description: "The register to be set",
                    type: "register"
                },
                value: {
                    description: "The value to set",
                    type: "any"
                }
            }
        });
    }
    Resolve(cursor: Cursor, parameters: MarshalParameters): boolean
    {
        if (parameters.key && parameters.key.reference && parameters.value)
        {
            cursor.setRegister(parameters.key.reference, parameters.value.value(cursor));
        }
        return true;
    }
}